export const DELIVERY_TYPE_META = {
  0: { icon: "mdi-motorbike", labelKey: "delivery_to_address" },
  1: { icon: "mdi-silverware-fork-knife", labelKey: "pickup" },
  2: { icon: "mdi-home", labelKey: "consumption_in_restaurant" },
};

export const STATUS_COLORS = {
  pending: "#fb8c00",
  accepted: "#1e88e5",
  "in-progress": "#00acc1",
  ready: "#8e24aa",
  "on-hold": "#757575",
  delivered: "#43a047",
  completed: "#43a047",
  cancelled: "#e53935",
};

export const NEXT_STATUS = {
  pending: "accepted",
  accepted: "in-progress",
  "in-progress": "ready",
  "on-hold": "accepted",
};

export const ACTIVE_STATES = ["pending", "accepted", "in-progress", "ready", "on-hold"];

// The 3 kitchen workflow groups, in left-to-right board order.
// "on-hold" shares the same "Na čekanju" label as "pending" so it belongs in
// the pending group, not preparing - preparing is strictly accepted/in-progress.
export const KDS_GROUPS = [
  {
    key: "pending",
    states: ["pending", "on-hold"],
    icon: "mdi-receipt-text-outline",
    accent: STATUS_COLORS.pending,
  },
  {
    key: "preparing",
    states: ["accepted", "in-progress"],
    icon: "mdi-pot-steam-outline",
    accent: STATUS_COLORS["in-progress"],
  },
  { key: "ready", states: ["ready"], icon: "mdi-food-takeout-box-outline", accent: STATUS_COLORS.ready },
];

export const DENSITY_OPTIONS = ["full", "compact", "minimal"];

export function toISODate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function groupForState(state) {
  const group = KDS_GROUPS.find((g) => g.states.includes(state));
  return group ? group.key : null;
}
